export {
  AntDesign,
  FontAwesome,
  Feather,
  Ionicons,
  SimpleLineIcons,
  MaterialIcons,
} from "./Icons/Icons";
